module.exports = __webpack_public_path__ + "img/7c09485.png";